
const DashboardLayout = () => import(/* webpackChunkName: "start" */'../components/Dashboard/Layout/DashboardLayout.vue')

const NotFound = () => import(/* webpackChunkName: "start" */'../components/GeneralViews/NotFoundPage.vue')

const Login = () => import(/* webpackChunkName: "start" */'src/components/Dashboard/Views/Pages/Login.vue')
const Forgot = () => import(/* webpackChunkName: "start" */'src/components/Dashboard/Views/Pages/Forgot.vue')
const Register = () => import(/* webpackChunkName: "start" */'src/components/Dashboard/Views/Pages/Register.vue')
const UserActivate = () => import(/* webpackChunkName: "start" */'src/components/Dashboard/Views/Pages/UserActivate.vue')
const ResetPassword = () => import(/* webpackChunkName: "start" */'src/components/Dashboard/Views/Pages/ResetPassword.vue')


const Index = () => import(/* webpackChunkName: "index" */'src/components/Dashboard/Views/Index/Index.vue')
const MeterIndex = () => import(/* webpackChunkName: "index" */'src/components/Applications/Views/Meter/Index.vue')

let loginPage = {
	path: '/login',
	name: 'Войти',
	component: Login
}
let forgotPage = {
	path: '/forgot',
	name: 'Восстановить доступ',
	component: Forgot
}

let ResetPasswordPage = {
	path: '/reset/:token',
	props: true,
	name: 'Установка нового пароля',
	component: ResetPassword
}

let registerPage = {
	path: '/register',
	name: 'Регистрация',
	component: Register
}

let activateUserAccountPage = {
	path: '/activate/:token',
	props: true,
	name: 'Активация аккаунта',
	component: UserActivate
}


const routes = [
	loginPage,
	forgotPage,
	registerPage,
	ResetPasswordPage,
	activateUserAccountPage,
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/index',
		children: [
			{
				path: 'index',
				name: 'Рабочий стол',
				component: Index
			}
		]
	},
	{
		path: '/meter',
		component: DashboardLayout,
		redirect: '/meter/index',
		children: [
			{
				path: '/meter/index',
				name: 'Мои Приборы учёта',
				component: MeterIndex
			}
		]
	},
	{
		path: '*',
		component: NotFound
	}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
 var res= require('../components/Dashboard/Views/' + name + '.vue');
 return res;
 };**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js